/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import { Tag } from "primereact/tag";
import {
  Boton,
  Titulo,
  Formulario,
  accessAPI,
  Sidebar,
  tituloBase,
  TablaFiltrable
} from "../../../../shared";

const SEARCH_FIELDS = ["nombre", "apellido"];

export default function Auditores() {
  const [loader, setLoader] = useState(true);
  const [auditores, setAuditores] = useState([]);
  const [sideBar, setSideBar] = useState(false);
  const [formLoader, setFormLoader] = useState(false);

  const toast = useRef(null);
  const navigate = useNavigate();

  function crearAuditor(camposFormulario) {
    setFormLoader(true);
    accessAPI(
      "POST",
      "admin/auditor",
      camposFormulario,
      (respuesta) => {
        navigate(`/proveedores/auditores/${respuesta.id}`);
      },
      (respuesta) => {
        setFormLoader(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al crear colaborador",
          sticky: true
        });
      }
    );
  }

  const crearFormConfig = {
    secciones: [
      {
        nombre: "Datos del colaborador",
        campos: [
          {
            nombre: "nombre",
            tipoitemformularioid: 1,
            etiqueta: "Nombre",
            requerido: true
          },
          {
            nombre: "apellido",
            tipoitemformularioid: 1,
            etiqueta: "Apellido",
            requerido: true
          },
          {
            nombre: "cedula",
            tipoitemformularioid: 1,
            etiqueta: "Cédula de identidad",
            requerido: true
          },
          {
            nombre: "email",
            tipoitemformularioid: 2,
            etiqueta: "Email",
            requerido: false
          },
          {
            nombre: "telefono",
            tipoitemformularioid: 1,
            etiqueta: "Teléfono",
            requerido: false
          }
        ]
      }
    ],
    botones: [
      { etiqueta: "Crear colaborador", callback: crearAuditor, validar: true }
    ]
  };

  useEffect(() => {
    document.title = "Colaboradores";
    accessAPI(
      "GET",
      "admin/auditor",
      null,
      (respuesta) => {
        setAuditores(respuesta);
        setLoader(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar colaboradores",
          sticky: true
        });
        setLoader(false);
      }
    );
    return () => (document.title = tituloBase());
  }, []);

  return (
    <>
      <Toast ref={toast} position="top-center" />

      <Sidebar
        visible={sideBar}
        onHide={() => setSideBar(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Nuevo colaborador</Titulo>
        <Formulario config={crearFormConfig} loader={formLoader} />
      </Sidebar>

      {loader && (
        <div css={{ marginTop: "2em", display: "flex", flexDirection: "column", gap: "0.5rem" }}>
          <div css={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
            <Skeleton width="15rem" height="2.5rem" />
            <div css={{ display: "flex", gap: "0.5rem" }}>
              <Skeleton width="14rem" height="2.5rem" />
              <Skeleton width="12rem" height="2.5rem" />
            </div>
          </div>
          <Card>
            <div css={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
              <Skeleton width="100%" height="3rem" />
              {[...Array(5)].map((_, i) => (
                <Skeleton key={i} width="100%" height="3.5rem" />
              ))}
            </div>
          </Card>
        </div>
      )}

      {!loader && (
        <div>
          <Titulo
            botones={
              <>
                <Boton transparente uri="/formacioncolaborador">
                  Requerimientos de formación
                </Boton>
                <Boton callback={() => setSideBar(true)}>Nuevo colaborador</Boton>
              </>
            }
          >
            Colaboradores
          </Titulo>

          <Card>
            <TablaFiltrable
              value={auditores}
              searchFields={SEARCH_FIELDS}
              anchoBusqueda="33%"
              nombreArchivo="colaboradores"
              stripedRows
              size="small"
              emptyMessage="No hay colaboradores registrados"
              onRowClick={(e) => {
                if (e.originalEvent.metaKey || e.originalEvent.ctrlKey) {
                  window.open(`/proveedores/auditores/${e.data.id}`, "_blank");
                } else {
                  navigate(`/proveedores/auditores/${e.data.id}`);
                }
              }}
              rowClassName={() => "cursor-pointer"}
            >
              <Column
                header="Nombre"
                body={(rowData) => (
                  <span
                    css={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      // Misma altura de fila que la tabla de clientes, donde
                      // el botón de acciones (~3rem) estira todas las filas
                      minHeight: "3rem"
                    }}
                  >
                    {rowData.nombre} {rowData.apellido}
                    {rowData.activo === false && (
                      <Tag severity="danger" value="Inactivo" />
                    )}
                    {rowData._count?.facturasColaborador > 0 && (
                      <Tag severity="warning" value="Factura pendiente" />
                    )}
                  </span>
                )}
              />
            </TablaFiltrable>
          </Card>
        </div>
      )}
    </>
  );
}
